// import React, { useEffect, useState } from 'react'
// import detailsOfBoard from 'utils/detailsOfBoard'
// import { useNavigate } from 'react-router-dom'
// import nonExecutives from 'utils/nonExecutives'
// // class="scroll-container h-64 overflow-y-auto"
// export default function DetailsOfBoard() {
//   const navigate = useNavigate()
//   return (
//     <section className='mt-4'>
//       <div className="flex flex-wrap justify-center gap-6">
//         {detailsOfBoard.map((item, index) => (
//           <div
//             key={index}
//             className="w-full sm:w-1/2 xl:w-1/4"
//             style={{ cursor: 'pointer' }} 
//             onClick={() => navigate(`/profile/${item.id}`)}
//           >
//             <DirectorCard 
//               title={item.title}
//               image={item.image}
//               post={item.post}
//             />
//           </div>
//         ))}
//       </div>
//       <div className="mt-4 mb-4 grid xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-6">
//         {nonExecutives.map((item, index) => {
//           return (
//             <div
//               key={index}
//               onClick={() => navigate(`/directors/${item.id}`)}
//               style={{ cursor: 'pointer' }} 
//             >
            
//               <DirectorCard
//                 key={index}
//                 title={item.title}
//                 image={item.image}
//                 post={item.post}
//               />
//             </div>
//           )
//         })}
//       </div>
//     </section>
//   )
// }

// function DirectorCard({
//   title,
//   post,
//   // desc,
//   image,
// }: {
//   title: string
//   post: string
//   // desc: string[]
//   image: string
// }) {
//   const [lineClamper, setLineClamper] = useState(false)
//   const [lineClampTimer, setLineClampTimer] = useState(false)

//   return (
//     <div className="bg-cream shadow-lg rounded-lg overflow-hidden flex flex-col items-center p-1.5">
//       <img
//         src={image}
//         alt={title}
//         className="w-[100%] h-auto rounded-xl md:rounded-[1.25rem] md:border-x-8 border-none"
//         // className="md:h-[15rem] w-[100%] rounded-xl md:rounded-[1.25rem] md:border-x-8 border-none 2xl:h-[16rem] xl:h-[14rem]"
//       />
//       <div className="mt-2 text-center">
//         <h5 className="text-sm xl:text-[12px] font-bold">{title}</h5>
//         <p className="text-sm">{post}</p>
//       </div>
//     </div>
//   )
// }
 
import React, { useEffect, useState } from 'react'
import detailsOfBoard from 'utils/detailsOfBoard'
import { useNavigate } from 'react-router-dom'
import nonExecutives from 'utils/nonExecutives'
// class="scroll-container h-64 overflow-y-auto"
export default function DetailsOfBoard() {
  const navigate = useNavigate()
  return (

    <section className='mt-4'>
      <div className="flex flex-wrap justify-center gap-6">
        {detailsOfBoard.map((item, index) => (
          <div
            key={index}
            className="w-full sm:w-1/2 xl:w-1/4"
            style={{ cursor: 'pointer' }} 
            onClick={() => navigate(`/profile/${item.id}`)}
          >
            <DirectorCard 
              title={item.title}
              image={item.image}
              post={item.post}
            />
          </div>
        ))}
      </div>
      <div className="mt-4 mb-4 grid xl:grid-cols-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-6">
        {nonExecutives.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => navigate(`/directors/${item.id}`)}
              style={{ cursor: 'pointer' }} 
            >
            
              <DirectorCard
                key={index}
                title={item.title}
                image={item.image}
                post={item.post}
              />
            </div>
          )
        })}
      </div>
    </section>
  )
}
 
function DirectorCard({
  title,
  post,
  // desc,
  image,
}: {
  title: string
  post: string
  // desc: string[]
  image: string
}) {
  const [lineClamper, setLineClamper] = useState(false)
  const [lineClampTimer, setLineClampTimer] = useState(false)
 
  return (
    <div className="bg-cream shadow-lg rounded-lg overflow-hidden flex flex-col items-center p-1.5">
      <img
        src={image}
        alt={title}
        className="w-[100%] h-auto rounded-xl md:rounded-[1.25rem] md:border-x-8 border-none"
        // className="md:h-[15rem] w-[100%] rounded-xl md:rounded-[1.25rem] md:border-x-8 border-none 2xl:h-[16rem] xl:h-[14rem]"
      />
      <div className="mt-2 text-center">
        <h5 className="text-sm xl:text-[12px] font-bold">{title}</h5>
        <p className="text-sm">{post}</p>
      </div>
    </div>
  )
}